'use client'
import {
  useTableStyles
} from "./chunk-GEJVU65N.mjs";

// src/tfooter.tsx
import { chakra, forwardRef } from "@chakra-ui/system";
import { jsx } from "react/jsx-runtime";
var Tfoot = forwardRef((props, ref) => {
  const styles = useTableStyles();
  return /* @__PURE__ */ jsx(chakra.tfoot, { ...props, ref, __css: styles.tfoot });
});

export {
  Tfoot
};
//# sourceMappingURL=chunk-B5H2YLEF.mjs.map